import MenuChatsSvg from 'components/svg/MenuChatsSvg';
import MenuFeedbacksSvg from 'components/svg/MenuFeedbacksSvg';
import MenuHomeSvg from 'components/svg/MenuHomeSvg';
import MenuSearchSvg from 'components/svg/MenuSearchSvg';
import MenuStarSvg from 'components/svg/MenuStarSvg';
import MenuUserSvg from 'components/svg/MenuUserSvg';
import { useIndexPageContext } from 'context/index_page_state';
import { useUserContext } from 'context/user_state';
import { ItemsNotificationType } from 'data/interfaces/INotification';
import { ProfileType } from 'data/interfaces/IRegistration';
import { useRouter } from 'next/router';
import { colors } from 'styles/variables';
import Button from '../Button';
import styles from './index.module.scss';

export default function MobileBottomMenu() {
  const userContext = useUserContext();
  const router = useRouter();
  const path = router.pathname;
  const indexPageContext = useIndexPageContext();

  const routes = {
    home: '/',
    messenger: '/messenger',
    recruiting: '/recruiting',
    favorites: '/favorites',
    feedbacks: '/profile?page=feedbacks',
    settings: '/settings',
  };

  return (
    <div className={styles.root}>
      <div className={styles.links}>
        <Button styleType={['icon', 'backTransparent']} href={routes.home}>
          <MenuHomeSvg color={path === routes.home ? colors.blue : colors.greyLight} />
        </Button>
        <Button styleType={['icon', 'backTransparent']} href={routes.messenger}>
          <MenuChatsSvg color={path === routes.messenger ? colors.blue : colors.greyLight} />
          {indexPageContext.unreadStats.find((el) => el.type === ItemsNotificationType.ChatMessage)
            ?.count > 0 && (
            <div className={styles.counter}>
              {
                indexPageContext.unreadStats.find(
                  (el) => el.type === ItemsNotificationType.ChatMessage,
                )?.count
              }
            </div>
          )}
        </Button>
        <Button styleType={['icon', 'gradient']} href={routes.recruiting}>
          <MenuSearchSvg />
        </Button>
        {(userContext?.currentProfile?.profileType === ProfileType.Hirer && (
          <Button styleType={['icon', 'backTransparent']} href={routes.favorites}>
            <MenuStarSvg color={path === routes.favorites ? colors.blue : colors.greyLight} />
          </Button>
        )) || (
          <Button styleType={['icon', 'backTransparent']} href={routes.feedbacks}>
            <MenuFeedbacksSvg color={path === routes.feedbacks ? colors.blue : colors.greyLight} />
            {indexPageContext.unreadStats.find(
              (el) => el.type === ItemsNotificationType.NewProposal,
            )?.count > 0 && (
              <div className={styles.counter}>
                {
                  indexPageContext.unreadStats.find(
                    (el) => el.type === ItemsNotificationType.NewProposal,
                  )?.count
                }
              </div>
            )}
          </Button>
        )}
        <Button styleType={['icon', 'backTransparent']} href={routes.settings}>
          <MenuUserSvg color={path === routes.settings ? colors.blue : colors.greyLight} />
        </Button>
      </div>
    </div>
  );
}
